import * as amplitude from '@amplitude/unified';

// Centralized Amplitude event tracking for Evoluras
const track = (eventName, properties = {}) => {
  try {
    amplitude.track(eventName, properties);
  } catch (e) {
    // Silently fail — analytics should never break the app
  }
};

// ── Auth Events ──
export const trackLogin = (userId) =>
  track('user_logged_in', { user_id: userId });

export const trackLogout = () =>
  track('user_logged_out');

// ── Page View ──
export const trackPageView = (pageName) =>
  track('page_viewed', { page: pageName });

// ── Wheel of Life ──
export const trackWheelSaved = ({ areasCount, focusAreasCount, avgScore }) =>
  track('wheel_saved', { areas_count: areasCount, focus_areas_count: focusAreasCount, avg_score: avgScore });

export const trackReflectionAdded = ({ areaKey, field, source }) =>
  track('reflection_added', { area: areaKey, field, source });

export const trackFocusAreasSelected = (focusAreas) =>
  track('focus_areas_selected', { focus_areas: focusAreas, count: focusAreas.length });

// ── SWOT ──
export const trackSwotItemAdded = (category) =>
  track('swot_item_added', { category });

export const trackSwotItemDeleted = (category) =>
  track('swot_item_deleted', { category });

// ── Insights ──
export const trackInsightRequestSent = ({ recipientCount, toolType }) =>
  track('insight_request_sent', { recipient_count: recipientCount, tool_type: toolType });

export const trackInsightSubmitted = ({ votesCount, suggestionsCount, isUpdate }) =>
  track('insight_submitted', { votes_count: votesCount, suggestions_count: suggestionsCount, is_update: isUpdate });

// ── Connections ──
export const trackInviteSent = (method) =>
  track('connection_invite_sent', { method });

export const trackConnectionAccepted = () =>
  track('connection_accepted');

// ── Core Values Pyramid ──
export const trackValuePlaced = ({ name, position, type }) =>
  track('value_placed', { name, position, type });

export const trackValueRemoved = ({ name, type }) =>
  track('value_removed', { name, type });

export const trackPyramidCompleted = ({ valuesCount, antiValuesCount }) =>
  track('pyramid_completed', { values_count: valuesCount, anti_values_count: antiValuesCount });

// ── Tool Navigation ──
export const trackToolOpened = (toolName, source) =>
  track('tool_opened', { tool: toolName, source });

// ── Identify user ──
export const identifyUser = (userId, properties = {}) => {
  try {
    const identifyObj = new amplitude.Identify();
    if (properties.email) identifyObj.set('email', properties.email);
    if (properties.name) identifyObj.set('name', properties.name);
    amplitude.setUserId(userId);
    amplitude.identify(identifyObj);
  } catch (e) {
    // Silently fail
  }
};
